import { 
    SEARCH_AFFILIATIONS 
   } from '../actions/types';

const initialState = {
    allAffiliations: [],
    keyword:''
}

export default (state = initialState, action) => {
   switch (action.type) {
       case SEARCH_AFFILIATIONS :
           return {
               ...state,
               allAffiliations : action.payload.allAffiliations,
               keyword: action.payload.keyword
           }
           break;
       default:
           return state;
           break;
   }
}